import React from 'react';
import style from './contactOwnerPopoverContent.scss';
import { Box, CloseButton, Loader } from 'wix-style-react';
import ArtifactDataHelper from './ArtifactDataHelper';

export const ContactOwnerPopoverContent = ({
  artifactData,
  isFetchingArtifactData,
  onCloseButtonClick,
}) => {
  return (
    <Box padding="28px 30px 30px" direction="vertical" width="384px">
      <CloseButton
        size="medium"
        className={style.closeButton}
        as="button"
        skin="dark"
        onClick={onCloseButtonClick}
      />
      {isFetchingArtifactData ? (
        <Box align="center" verticalAlign="middle">
          <Loader size="small" dataHook="fetching-artifact-data-loader" />
        </Box>
      ) : (
        <ArtifactDataHelper
          slackChannels={artifactData.slackChannels}
          jiraProjects={artifactData.jiraProjects}
          company={artifactData.company}
        />
      )}
    </Box>
  );
};
